<template>
  <div class="customer-box">
    <banner-control></banner-control>
    <div class="w-box">
      <div class="container">
        <div class="from">
          <ul class="navbar-box">
            <li
              class="navbar-item"
              v-for="(item, index) in industryList"
              :key="index"
              :class="{ active: industry == item.id }"
              @click="changeIndustry(item)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>

        <div class="lists">
          <div
            class="list"
            v-for="(item, index) in show"
            :key="index"
            @click="viewHandler(item)"
          >
            <div class="inner">
              <div class="logo"><img :src="item.url" /></div>
              <div class="name">{{ item.name }}</div>
              <div class="info">{{ item.info }}</div>
            </div>
          </div>
        </div>
        <customer-dialog
          v-if="isDialogShow"
          :item="nowItem"
          :list="list"
          @close="isDialogShow = false"
        />
        <single-customer-dialog
          :item="nowItem"
          :dialogVisible="singleDialogShow"
          @handleClose="handleClose"
        ></single-customer-dialog>
        <div class="pagination" v-if="filters.length > 9">
          <my-pagination
            @currentChangeHandle="handleCurrentChange"
            :currentPage="page"
            :total="filters.length"
            :size="9"
            background
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN_API } from "@/api.js";
import bannerControl from '@/components/customer/banner.vue'
import CustomerDialog from '@/components/customer/customer-dialog.vue'
import singleCustomerDialog from '@/components/customer/single-customer-dialog.vue'
export default {
  components: {
    bannerControl,
    CustomerDialog,
    singleCustomerDialog,
  },
  data() {
    return {
      industry: 0,
      industryList: [
        { id: 0, label: '全部行业' },
        { id: 1, label: 'IT互联网' },
        { id: 2, label: '餐饮零售' },
        { id: 3, label: '房地产' },
        { id: 4, label: '工业制造' },
        { id: 5, label: '物流/运输' },
        { id: 6, label: '学校/教育' },
        { id: 7, label: '医疗健康' },
        { id: 8, label: '银行/金融' },
        { id: 9, label: '政府/政务' },
        { id: 10, label: '咨询/服务' },
      ],

      list: [],
      page: 1,
      filters: [],
      show: [],

      isDialogShow: false,
      singleDialogShow: false,
      nowItem: [],
    }
  },
  created() {
    this.loadDate()
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    isMobile() {
      return this.$store.state.app.device
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val
      this.load()
    },
    changeIndustry(val) {
      this.page = 1
      this.industry = val.id
      this.load()
    },
    load() {
      let filters = []
      if (this.industry == 0) {
        filters = this.list
      } else {
        filters = this.list.filter((item) => item.industry == this.industry)
      }
      this.filters = filters
      let show = []
      filters.map((item, index) => {
        if (index >= (this.page - 1) * 9 && index < this.page * 9) {
          show.push(item)
        }
      })
      this.show = show
    },
    //点击公司查看详情
    viewHandler(item) {
      this.nowItem = item

      if (this.isMobile) {
        this.singleDialogShow = true
        return
      }
      this.isDialogShow = true
    },
    handleClose() {
      this.singleDialogShow = false
    },
    loadDate() {
      let post = {
        category: 31,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              this.list = res.data.result[0].data
              this.load()
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-box {
  .w-box {
    background: #fff url('/static/images/wbg.png') repeat-x;
  }
  .container {
    padding: 50px 0px 50px;
    font-weight: 300;
    min-height: 500px;
    .from {
      width: 1200px;
      margin: 0px auto;
      padding: 20px;
      background: #fff;
      border: 1px solid #dedede;
      display: flex;
      ul {
        li {
          display: inline;
          padding: 6px 15px;
          font-size: 14px;
          cursor: pointer;
          margin-right: 10px;
          &.active,
          &:hover {
            background: #29bdb9;
            color: #fff;
            border-radius: 5px;
          }
        }
      }
    }
    .lists {
      width: 1200px;
      margin: 20px auto 0px;
      .list {
        width: 32%;
        display: inline-block;
        margin: 0px 2% 2% 0px;
        cursor: pointer;
        &:hover {
          box-shadow: #eff0f2 0px 2px 12px 6px;
        }
        &:nth-child(3n) {
          margin-right: 0px;
        }
        .inner {
          background: #fff;
          padding: 20px;
          border: 1px solid #dedede;
          text-align: center;
          width: 100%;
          height: 200px;
          .logo {
            height: 80px;
            padding: 10px 0 20px 0;
            img {
              max-width: 100%;
              max-height: 60px;
            }
          }
          .name {
            padding: 8px 0px;
            font-size: 18px;
          }
          .info {
            padding-top: 10px;
            font-size: 14px;
          }
        }
      }
    }
    .pagination {
      text-align: center;
    }
  }
}
@media screen and (max-width: 600px) {
  .customer-box {
    .container {
      padding: 0px 0px 30px;
      .from {
        margin: 0;
        border: 0;
        border-bottom: 1px solid #dedede;

        width: initial;
        ul {
          text-align: center;
          white-space: nowrap;
          overflow-x: scroll;
          overflow-y: hidden;
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
          li {
            font-size: 16px;
            white-space: nowrap;
            display: inline-block;
            &.active,
            &:hover {
              background: #29bdb9;
              color: #fff;
              border-radius: 5px;
            }
          }
        }
      }
      .lists {
        width: initial;
        padding: 0 10px;
        .list {
          width: 100%;
          padding: 10px 15px;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .customer-box {
    .container {
      padding: 0px 0px 30px;
      .from {
        margin: 0;
        border: 0;
        border-bottom: 1px solid #dedede;

        width: initial;
        ul {
          text-align: center;
          white-space: nowrap;
          overflow-x: scroll;
          overflow-y: hidden;
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
          li {
            font-size: 16px;
            white-space: nowrap;
            display: inline-block;
            &.active,
            &:hover {
              background: #29bdb9;
              color: #fff;
              border-radius: 5px;
            }
          }
        }
      }
      .lists {
        width: initial;
        padding: 0 10px;
        .list {
          width: 49%;
          display: inline-block;
          padding: 10px 15px;
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/index.vue